import React from "react";
import { IIconProps } from "./Icon/Interfaces";

const MinusIcon = ({
  width = 21,
  height = 22,
  strokeColor = "var(--blue)",
}: IIconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none">
      <rect
        x="12"
        y="5"
        width="2"
        height="12"
        rx="1"
        transform="rotate(90 12 5)"
        fill={strokeColor}
      />
    </svg>
  );
};

export default MinusIcon;
